import { ReactNode } from 'react';
import { useInView, animated } from '@react-spring/web';

interface FadeInOnViewProps {
  children: ReactNode;
}

export function FadeInOnView({ children }: FadeInOnViewProps) {
  const [ref, springs] = useInView(
    () => ({
      from: { opacity: 0, y: 100 },
      to: { opacity: 1, y: 0 },
      config: { tension: 220, friction: 20 },
    }),
    { rootMargin: '0px', once: true }
  );

  return (
    <animated.div ref={ref} style={springs}>
      {children}
    </animated.div>
  );
}
